import {
  ApiConditionGroup,
  ApiConversion,
  ApiEngagementRule,
  ApiProject,
} from "@incendium/api";
import { useConditionGroupContext } from "Components/ConditionalGroup/ConditionGroupProvider";
import EngagementRules from "features/leadScore/components/EngagementRules";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { useEngagements } from "Hooks/useEngagements";
import produce from "immer";
import ConditionGroupsFormWrapper from "Components/ConditionalGroup/ConditionGroupsFormWrapper";
import { CallbackOrVal } from "Interfaces";
import EngagementSidebar from "features/leadScore/components/EngagementSidebar";
import { saveLeadScoreEngagementRule } from "features/leadScore/services/leadScoreService";
import { useNotification } from "Hooks";
interface IEngagementFormProps {
  engagement: ApiEngagementRule;
  setEngagement: (v: CallbackOrVal<ApiEngagementRule | undefined>) => void;
  conversions: ApiConversion[];
  project: ApiProject;
  isNew?: boolean;
}

function EngagementForm({
  engagement,
  setEngagement,
  conversions,
  project,
  isNew,
}: IEngagementFormProps) {
  const { conditionGroups, setConditionGroups } = useConditionGroupContext();
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const { engagements, setEngagements } = useEngagements();

  const history = useHistory();

  useEffect(() => {
    return () => {
      setConditionGroups([]);
      setEngagement(undefined);
    };
  }, []);

  useEffect(() => {
    if (!engagement || conditionGroups.length) {
      return;
    }
    const groups = engagement.conditionGroups || [];
    setConditionGroups(
      groups && groups.length > 0
        ? [...groups]
        : [
          {
            conditions: [{}],
          },
        ]
    );
  }, [engagement, setConditionGroups, conditionGroups]);

  const onSubmit = async () => {
    try {
      const res = await saveLeadScoreEngagementRule(project.id as number, {
        ...engagement,
        conditionGroups: conditionGroups as ApiConditionGroup[],
        id: isNew ? undefined : engagement.id,
      });
      showSuccessNotification(`${res.name} Saved`);

      // update list
      setEngagements(
        produce(engagements, (draft) => {
          if (isNew) {
            draft.push(res);
            return;
          }
          const idx = engagements.findIndex((e) => e.id === engagement.id);
          if (idx < 0) {
            return;
          }
          draft[idx] = res;
        })
      );

      if (isNew && history.location.pathname.includes("new")) {
        history.push(`/clients/${project.clientId}/projects/${project?.id}/train/lead-scoring/${res.id}`);
      }
    } catch (error) {
      console.error(error);
      showErrorNotification("Error saving engagement");
    }
  };

  const onCancel = () => {
    history.push(
      `/clients/${project.clientId}/projects/${project?.id}/train/lead-scoring`
    );
  };

  return (
    <ConditionGroupsFormWrapper
      onSubmit={onSubmit}
      onCancel={onCancel}
      rulesComponent={EngagementRules}
      rulesComponentProps={{
        conversions,
      }}
    >
      <EngagementSidebar
        engagement={engagement}
        setEngagement={setEngagement}
      />
    </ConditionGroupsFormWrapper>
  );
}

export default EngagementForm;
